import { Component, Inject } from '@angular/core';
import{MatDialogRef,MAT_DIALOG_DATA } from "@angular/material/dialog"
import { FormBuilder, FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';

@Component({
    selector: 'app-verticalvessel',
    templateUrl: './verticalvessel.component.html',
    styleUrls: ['./verticalvessel.component.css'],
    standalone: false
})
export class VerticalvesselComponent {
  verticalform : FormGroup;
  input1: number;
  input2: number;
  // input1 = new FormControl('',Validators.required);
  // input2 = new FormControl('',Validators.required);
  resultmessage : string;
  x1: any;
  x2: any;
  Result:string ="";
  Result1:boolean;
  isDisabled: boolean = true;
  path: string;
  typaResult:boolean = null;
  intUnit:number;
  myColor: string = ""; 
  
  
  constructor(private router: Router, private formBuilder:FormBuilder, public dialogRef:MatDialogRef<VerticalvesselComponent>,@Inject(MAT_DIALOG_DATA) public data: any){
    this.intUnit = parseInt(localStorage.getItem("unitType")) || 0; // 0 - US, 1 - SI
  }
  ngOnInit(){
    this.verticalform = this.formBuilder.group (
      {
        input1: new FormControl('',Validators.required),
        input2: new FormControl('',Validators.required),
      }
    )

    // to load the inputs with values if already entered.
    // this.loadoldinputs();
}
  closeDialog(){
    // for Cancel button click
      this.dialogRef.close({ cancel: true, value: [] });
     }
  BacktoALS(){
    // for the Next button click

   // this.dialogRef.close(this.typaResult);
    // to tell as it is returning from Next button
   // this.data2 = this.typaResult;
   if ((this.verticalform.get('input1').invalid) || (this.verticalform.get('input2').invalid))
    {
     this.Result = "Please enter the correct values.";
     this.isDisabled = true;
     this.typaResult = null;
     this.myColor = 'red'; 
    }
    else{
      
    
     this.dialogRef.close({ cancel: false, value: [2 , this.typaResult] });
    }
  }

  onSubmit()
  {
    //for Calculate button
          this.x1 = this.verticalform.controls.input1.value;
          this.x2 = this.verticalform.controls.input2.value;

          if ((this.verticalform.get('input1').invalid) || (this.verticalform.get('input2').invalid))
            {
              this.Result = "Please enter the correct values.";
              this.isDisabled = true;
              this.typaResult = null;
              this.myColor = 'red'; 
            }
            else
            {
              if(this.x1 <= 0 || this.x2 <= 0)
                {
                  this.Result = "Check your input! Please enter values greater than zero.";
                  this.myColor = 'red'; 
                }
                else
               {

                  if(this.intUnit == 0)  //us customary
                  {
                  if (((this.x1/this.x2) <= 3) && (this.x1 <= 1200))
                    {
                      this.Result ="The Component meets Type A screening criteria."
                      this.isDisabled = false;
                      this.typaResult = true;
                      this.myColor = 'green'; 
                                         
                    // for keeping inputs in local storage
                      const verticalinputs1 = { inputvalue1 :this.x1 , inputvalue2: this.x2 };
                      localStorage.setItem('verticalinputs', JSON.stringify(verticalinputs1));

                    // for keeping radio button in local storage
                      const inputradbtn = { radval : "1"};
                      localStorage.setItem('inputradbtnval', JSON.stringify(inputradbtn));

                                   
                     
                    }
                    else
                    {
                      this.Result ="The Component doesn't meet the Type A component criteria."
                      this.isDisabled = false;
                      this.typaResult = false;
                      this.myColor = 'red'; 
                      
                      const verticalinputs1 = { inputvalue1 :this.x1 , inputvalue2: this.x2 };
                      localStorage.setItem('verticalinputs', JSON.stringify(verticalinputs1));

                      
                    }
                  }
                  else if(this.intUnit == 1) //si units
                  {
                    if (((this.x1/this.x2) <= 3) && (this.x1 <= 30500))
                      {
                        this.Result ="The Component meets the Type A screening criteria."
                        this.isDisabled = false;
                        this.typaResult = true;
                        this.myColor = 'green'; 


                        const verticalinputs1 = { inputvalue1 :this.x1 , inputvalue2: this.x2 };
                        localStorage.setItem('verticalinputs', JSON.stringify(verticalinputs1));
                       
                        
                      }
                      else
                      {
                        this.Result ="The Component doesn't meet the Type A component criteria."
                        this.isDisabled = false;
                        this.typaResult = false;
                        this.myColor = 'red'; 
                        let txt:string = this.x1+","+this.x2

                        const verticalinputs1 = { inputvalue1 :this.x1 , inputvalue2: this.x2 };
                        localStorage.setItem('verticalinputs', JSON.stringify(verticalinputs1));
                        
                      
                      }
                  }
                }

            }

          
         
  }

  // loadoldinputs()
  // {
  //   const userinputs = localStorage.getItem('verticalinputs');
  //   const Input_data = userinputs ? JSON.parse(userinputs) : null
  //   const a1 = Input_data.inputvalue1;
  //   const a2 = Input_data.inputvalue2;
  //   if((a1!="")||(a2!=""))
  //   {
  //   this.verticalform.controls.input1.setValue(Number(a1));
  //   this.verticalform.controls.input2.setValue(Number(a2));

  //   this.onSubmit();//calling Calculate button
  //   }
  // }
   
}
